import { render, staticRenderFns } from "./salesperson_vue.vue?vue&type=template&id=79964c74&scoped=true&"
import script from "./salesperson_vue.vue?vue&type=script&lang=js&"
export * from "./salesperson_vue.vue?vue&type=script&lang=js&"
import style0 from "./salesperson_vue.vue?vue&type=style&index=0&id=79964c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79964c74",
  null
  
)

export default component.exports